(function($){
    
    document.addEventListener("DOMContentLoaded", function() {
        const lazyBackgrounds = document.querySelectorAll(".lazy-bg");
    
        if ("IntersectionObserver" in window) {
            let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyBackground = entry.target;
                        lazyBackground.style.backgroundImage = `url('${lazyBackground.dataset.bg}')`;
                        lazyBackground.classList.remove("lazy-bg");
                        lazyBackgroundObserver.unobserve(lazyBackground);
                    }
                });
            });
    
            lazyBackgrounds.forEach(function(lazyBackground) {
                lazyBackgroundObserver.observe(lazyBackground);
            });
        } else {
            // Fallback per i browser senza supporto a IntersectionObserver
            lazyBackgrounds.forEach(function(lazyBackground) {
                lazyBackground.style.backgroundImage = `url('${lazyBackground.dataset.bg}')`;
            });
        }
    });
    
    jQuery(".search-btn").click(function(){
        jQuery(".header_search").toggleClass("active");
     });

     $(".cv-upload").unbind("click").bind("click", function () {
        $(".field-cv").click();
     });
  
     $(".field-cv").change(function(){
        var fullPath = $(".field-cv").val();
        var filename = fullPath.replace(/^.*[\\\/]/, '');
        $(".cv_name").text(filename);
        $(".cv_name").addClass('active');
     });
     $('.cv_name').click(function(){
         const file = document.querySelector('.field-cv');
         file.value = '';
         $(".cv_name").removeClass('active');
         $(".cv_name").text('');
      });

      $('a.dropdown-toggle').click(function(){
        var id = this.id;
        $('.'+id).toggleClass('active');
        $(".dropdown-menu:not(."+id+")").removeClass('active');
        $(this).toggleClass('active');
     }); 

     document.querySelectorAll('.custom-select').forEach(select => {
        let selected = select.querySelector('.selected');
        let options = select.querySelector('.options');
    
        selected.addEventListener('click', function () {
            closeAllSelects(); // Chiude gli altri select prima di aprire questo
            select.classList.toggle('active');
        });
    
        options.querySelectorAll('li').forEach(option => {
            option.addEventListener('click', function () {
                selected.textContent = this.textContent;
                select.classList.remove('active');
            });
        });
    });
    
    // Chiude tutti i select quando si clicca fuori
    document.addEventListener('click', function (e) {
        if (!e.target.closest('.custom-select')) {
            closeAllSelects();
        }
    });
    
    function closeAllSelects() {
        document.querySelectorAll('.custom-select').forEach(select => {
            select.classList.remove('active');
        });
    }
    
    function initFilter( forms ) {
        if( !forms ){
           return
        }
        forms.forEach( (formFilters, i) => {
           "use strict";
           const formSelects = Array.from(formFilters.querySelectorAll('input'));
           formSelects.forEach( (element, i) => {
              element.addEventListener('change', () => {
                    formFilters.submit();
              })
           });
        });
     }
     window.addEventListener('load', () => {
        initFilter( Array.from(document.querySelectorAll('.atex_filter')) );
     })

     $('.hamburger').click(function() {
      $('.hamburger, #mobile-menu').toggleClass('is-active');
      $('body').toggleClass('menu-open');
   });

   $('a.sub_toggle').click(function(){
    var id = this.id;
    $('.'+id).toggleClass('active');
    $(".submenuthird:not(."+id+")").removeClass('active');
    $("a.sub-toggle:not(."+id+")").removeClass('active');
    });

  $('a.back_toggle').click(function(){
      $(".submenuthird").removeClass('active');
  });
  $('.sub-toggle').click(function(){
    var id = this.id;
    $('.'+id).toggleClass('active');
    //$(".navigation-second:not(."+id+")").removeClass('active');
    $(this).toggleClass('active');
 });

 window.onload = function() {
    const targetId = window.location.hash.substring(1); 
    if (targetId) {
        const target = document.getElementById(targetId);
        if (target) {
            setTimeout(() => {
                window.scrollTo({
                    top: target.offsetTop - 50, 
                    behavior: "smooth"
                });
            }, 100); 
        }
    }
};

})(jQuery);

